import { makeAutoObservable, runInAction } from "mobx";
import { useMemo } from "react";

export class ExpandCallapseStore {
    private _map: { [key: string]: boolean } = {};
    
    constructor(private isExpandedInitially: boolean) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public setExpanded(key: string, v: boolean): void {
        this._map[key] = v;
    }

    public getIsExpanded(key: string): boolean {
        if (this._map[key] === undefined) {
            runInAction(() => {
                this._map[key] = this.isExpandedInitially;
            })
        }
        return this._map[key];
    }

    public isAllExpanded(): boolean {
        return Object.values(this._map).every(v => v);
    }

    public toggleAllExpanded(): void {
        const newIsExpandedValue = !this.isAllExpanded();
        for (let i in this._map) {
            this._map[i] = newIsExpandedValue;
        }
    };
}

const useExpandCollapse = (isExpandedInitially: boolean = false): ExpandCallapseStore => {
    return useMemo(() => new ExpandCallapseStore(isExpandedInitially), [isExpandedInitially]);
}

export default useExpandCollapse;
